import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  OnInit,
  Output,
} from '@angular/core';

@Component({
  selector: 'app-copy-document-action',
  templateUrl: 'copy-document-action.component.html',
  styleUrls: ['copy-document-action.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CopyDocumentActionComponent implements OnInit {
  @Output()
  onOpenCopyDocumentDialog: EventEmitter<void> = new EventEmitter<void>();

  constructor() {}

  ngOnInit() {}

  openCopyDocumentDialog() {
    this.onOpenCopyDocumentDialog.emit();
  }
}
